import React from "react";

const Snapshots = () => {
  return (
    <div className="snap-wrap">
      <div className="snapshot">
        <div className="titles">
          <span>Top spending users</span>
          <span>View Details</span>
        </div>
        <div className="card">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>A Chandram</td>
                <td>Rs. 1987.00</td>
              </tr>
              <tr>
                <td>Ajay Kumar Agarwal</td>
                <td>Rs. 1007.00</td>
              </tr>
              <tr>
                <td>Annabathuni Subba</td>
                <td>Rs. 987.00</td>
              </tr>
              <tr>
                <td>A Chandram</td>
                <td>Rs. 587.00</td>
              </tr>
              <tr>
                <td>Ajay Kumar Agarwal</td>
                <td>Rs. 1087.00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="snapshot">
        <div className="titles">
          <span>Top Vendors</span>
          <span>View Details</span>
        </div>
        <div className="card">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>A Chandram</td>
                <td>Rs. 1987.00</td>
              </tr>
              <tr>
                <td>Ajay Kumar Agarwal</td>
                <td>Rs. 1007.00</td>
              </tr>
              <tr>
                <td>Annabathuni Subba</td>
                <td>Rs. 987.00</td>
              </tr>
              <tr>
                <td>A Chandram</td>
                <td>Rs. 587.00</td>
              </tr>
              <tr>
                <td>Ajay Kumar Agarwal</td>
                <td>Rs. 1087.00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="snapshot">
        <div className="titles">
          <span>Top Categories</span>
          <span>View Details</span>
        </div>
        <div className="card">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>A Chandram</td>
                <td>Rs. 1987.00</td>
              </tr>
              <tr>
                <td>Ajay Kumar Agarwal</td>
                <td>Rs. 1007.00</td>
              </tr>
              <tr>
                <td>Annabathuni Subba</td>
                <td>Rs. 987.00</td>
              </tr>
              <tr>
                <td>A Chandram</td>
                <td>Rs. 587.00</td>
              </tr>
              <tr>
                <td>Ajay Kumar Agarwal</td>
                <td>Rs. 1087.00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="snapshot">
        <div className="titles">
          <span>Top Violations</span>
          <span>View Details</span>
        </div>
        <div className="card">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>A Chandram</td>
                <td>Rs. 1987.00</td>
              </tr>
              <tr>
                <td>Ajay Kumar Agarwal</td>
                <td>Rs. 1007.00</td>
              </tr>
              <tr>
                <td>Annabathuni Subba</td>
                <td>Rs. 987.00</td>
              </tr>
              <tr>
                <td>A Chandram</td>
                <td>Rs. 587.00</td>
              </tr>
              <tr>
                <td>Ajay Kumar Agarwal</td>
                <td>Rs. 1087.00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Snapshots;
